import {lowerCaseArray} from '~utils/miscUtils';

import {mapStringNullToNull} from '~components/images/image-overview/toolbar/utils';
import {NO_ANNOTATED_KEY, NO_DEFECTS_KEY, NO_OBJECTS_KEY} from 'src/constants/constants';
import {ImageFiltersPayload} from './images';

export const processFilters = (filters: ImageFiltersPayload | undefined, metadata?: MetadataFilters) => {
  let productTypes;
  let meta: Record<string, (string | number | null)[] | undefined> | undefined;
  let metaRange: Record<string, {min: number; max: number}> | undefined;

  if (filters?.meta) {
    meta = mapStringNullToNull(filters.meta);

    // Process numerical metadata into metaRange
    if (metadata && meta) {
      const numericalMeta: Record<string, {min: number; max: number}> = {};

      Object.entries(meta).forEach(([key, values]) => {
        const metadataInfo = metadata[key];
        if (metadataInfo?.widgetType === 'numerical' && values && Array.isArray(values)) {
          const numValues = values.filter((v): v is number => typeof v === 'number');
          if (numValues.length >= 2) {
            numericalMeta[key] = {
              min: Math.min(...numValues),
              max: Math.max(...numValues),
            };
          }
        }
      });

      if (Object.keys(numericalMeta).length > 0) {
        metaRange = numericalMeta;

        // Remove numerical fields from meta to avoid duplication
        Object.keys(numericalMeta).forEach((key) => {
          delete meta![key];
        });

        // If meta is now empty, set it to undefined
        if (Object.keys(meta).length === 0) {
          meta = undefined;
        }
      }
    }
  }

  if (Array.isArray(filters?.productType)) {
    productTypes = filters.productType;
  } else if (filters?.productType) {
    productTypes = [filters.productType];
  }

  productTypes = productTypes?.reduce(
    (acc, productType) => {
      if (productType === 'null') {
        return [...acc, null];
      }
      return [...acc, productType];
    },
    [] as (string | null)[],
  );

  // When confusionCell is an array (e.g. accuracy "view images" with multiple diagonal cells),
  // send it as `confusionCells` (plural) to the API and remove the singular `confusionCell`.
  const isConfusionCellArray = Array.isArray(filters?.confusionCell);
  const confusionCellFields = isConfusionCellArray
    ? {confusionCell: undefined, confusionCells: filters?.confusionCell}
    : {};

  return {
    ...filters,
    ...confusionCellFields,
    machinePredictionLabels: filters?.machinePredictionLabels?.filter(
      (label) => label !== NO_DEFECTS_KEY && label !== NO_OBJECTS_KEY,
    ),
    humanAnnotationLabels: filters?.humanAnnotationLabels?.filter((label) => label !== NO_ANNOTATED_KEY),
    excludeHumanAnnotationLabels: filters?.excludeHumanAnnotationLabels?.filter((label) => label !== NO_ANNOTATED_KEY),
    isPredictedOnlyByModel: filters?.isPredictedOnlyByModel,
    withoutMachineDefectPredictions: filters?.withoutMachineDefectPredictions,
    withoutMachineObjectPredictions: filters?.withoutMachineObjectPredictions,
    withNoImages: Boolean(filters?.withNoImages),
    latestLabelers: lowerCaseArray(filters?.latestLabelers),
    labelers: lowerCaseArray(filters?.labelers),
    productType: productTypes,
    meta,
    metaRange,
  };
};
